<template>
    <app-layout title="Creditnota's">
        <template #header>
            <page-title title="Creditnota's" />
        </template>

        <template #pageContent>
            <div class="">
                <TableSearch :tableId="'overview-credit-notes' + status" :values="creditNotes" class="w-1/4" placeholder="Zoeken"/>
            </div>

            <Table :id="'overview-credit-notes' + status" :values="creditNotes" class="mt-4">
                <thead>
                <tr>
                    <Th id="request.reference">Referentie aanvraag</Th>
                    <Th id="status_request_trans">Status aanvraag</Th>
                    <Th id="reference">Referentie creditnota</Th>
                    <Th id="status_credit_note_trans">Status creditnota</Th>
                    <Th :sort="false"></Th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="creditNote in state.sortedValues['overview-credit-notes' + status]" :key="creditNote.id">
                    <Td>{{ creditNote.request.reference }}</Td>
                    <Td>{{ creditNote.status_request_trans }}</Td>
                    <Td>{{ creditNote.reference }}</Td>
                    <Td>{{ creditNote.status_credit_note_trans }}</Td>
                    <Td>
                        <Button
                            htmlType="a"
                            buttonClass="show"
                            size="small"
                            title="Details"
                            :href="route('accountancy.credit-notes.show',  {'id': creditNote.id})"
                        />
                        <Button
                            htmlType="a"
                            buttonClass="edit"
                            size="small"
                            title="Bewerken"
                            :href="route('accountancy.credit-notes.edit', { 'id': creditNote.id })"
                        />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'

import store from '@/store'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
    },
    props: [
        'creditNotes',
        'status',
    ],
    setup (props){

        return {
            state: store.state,
            ...store,
        }
    },
}

</script>
